import React from "react";
import "./GetMusicOnJioSaavn.css";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Helmet } from "react-helmet";

const GetMusicOnJioSaavn = () => {

  const steps = [
    "Create your FTTunes account",
    "Upload music & artwork",
    "Deliver music to JioSaavn",
    "Get your artist profile live",
    "Grow your listeners in India",
    "Track streams & royalties"
  ];

  return (
    <>
      <Helmet>

        <title>
          Get Your Music on JioSaavn | JioSaavn Music Distribution India | FT Tunes
        </title>

        <meta
          name="description"
          content="Distribute your music on JioSaavn with FT Tunes. Upload songs easily, reach millions of listeners across India, and grow your artist profile professionally."
        />

        <meta
          name="keywords"
          content="JioSaavn music distribution, upload music to JioSaavn, JioSaavn for artists India, music distribution India, FT Tunes distribution, release music India"
        />

        <meta name="robots" content="index, follow" />
        <meta name="author" content="FT Tunes" />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Get Your Music on JioSaavn | FT Tunes"
        />

        <meta
          property="og:description"
          content="Release your music on JioSaavn and reach millions of Indian listeners. Fast approval and global distribution with FT Tunes."
        />

        <meta property="og:type" content="website" />

        <meta
          property="og:url"
          content="https://www.fttunes.com/get-your-music-on-jiosaavn"
        />

      </Helmet>

      <div className="jiosaavn-page">

        {/* HERO */}
        <section className="jiosaavn-hero">
          <Container>

            <img
              src="/Images/jiosaavn.png"
              alt="Get Music on JioSaavn"
            />

            <h1>
              JioSaavn for Artists <br /> Get Your Music Live
            </h1>

            <p>
              Release your music on JioSaavn and connect with millions of
              listeners across India using FT Tunes music distribution.
            </p>

            <Button
              className="gradient-btn"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
              rel="noopener noreferrer"
            >
              Start Releasing Music
            </Button>

          </Container>

          <div className="hero-glow"></div>
        </section>

        {/* SHOWCASE */}
        <section className="jiosaavn-showcase">
          <Container>
            <Row className="align-items-center">

              <Col md={6}>
                <h2>Reach India’s Biggest Music Audience</h2>

                <p>
                  JioSaavn is one of India's leading music streaming platforms.
                  Upload your music, grow your fanbase, and earn royalties from
                  every stream.
                </p>

                <Button
                  as="a"
                  className="outline-btn"
                  href="https://dashboard.fttunes.com/register.php"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Distribute Now
                </Button>
              </Col>

              <Col md={6}>
                <img
                  src="/Images/get-your-music-on-jiosavn.png"
                  alt="JioSaavn Distribution"
                  className="jiosaavn-image"
                />
              </Col>

            </Row>
          </Container>
        </section>

        {/* STEPS */}
        <section className="jiosaavn-steps">
          <Container>

            <h2 className="section-title">
              How It Works
            </h2>

            <Row>
              {steps.map((step, index) => (
                <Col md={4} key={index}>
                  <div className="step-card">
                    <span>0{index + 1}</span>
                    <p>{step}</p>
                  </div>
                </Col>
              ))}
            </Row>

          </Container>
        </section>

        {/* BENEFITS */}
        <section className="jiosaavn-benefits">
          <Container>

            <h2 className="section-title">
              Built For Independent Artists
            </h2>

            <Row>

              <Col md={3}>
                <div className="benefit-card">
                  <h5>Massive Indian Reach</h5>
                  <p>Connect with millions of listeners across India.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card">
                  <h5>Keep Your Rights</h5>
                  <p>You retain 100% ownership of your music.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card">
                  <h5>Royalty Earnings</h5>
                  <p>Earn revenue whenever your music streams.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card">
                  <h5>Artist Growth</h5>
                  <p>Build your brand and expand your audience.</p>
                </div>
              </Col>

            </Row>

          </Container>
        </section>

        {/* CTA */}
        <section className="jiosaavn-cta">
          <Container>
            <h2>Start Growing on JioSaavn Today</h2>

            <Button
              className="gradient-btn big"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
            >
              Upload Your Music
            </Button>

          </Container>
        </section>

      </div>
    </>
  );
};

export default GetMusicOnJioSaavn;